/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getNutritionIPS } from 'app/entities/nutrition-ip/nutrition-ip.reducer';
import { getEntities as getNutritionOrders } from 'app/entities/nutrition-order/nutrition-order.reducer';
import { createEntity, getEntity, reset, updateEntity } from './nutrition-order-item.reducer';

export const NutritionOrderItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const nutritionIPS = useAppSelector(state => state.nutritionIP.entities);
  const nutritionOrders = useAppSelector(state => state.nutritionOrder.entities);
  const nutritionOrderItemEntity = useAppSelector(state => state.nutritionOrderItem.entity);
  const loading = useAppSelector(state => state.nutritionOrderItem.loading);
  const updating = useAppSelector(state => state.nutritionOrderItem.updating);
  const updateSuccess = useAppSelector(state => state.nutritionOrderItem.updateSuccess);

  const handleClose = () => {
    navigate(`/nutrition-order-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getNutritionIPS({}));
    dispatch(getNutritionOrders({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.total !== undefined && typeof values.total !== 'number') {
      values.total = Number(values.total);
    }
    if (values.dailyTotal !== undefined && typeof values.dailyTotal !== 'number') {
      values.dailyTotal = Number(values.dailyTotal);
    }

    const entity = {
      ...nutritionOrderItemEntity,
      ...values,
      nutrition: nutritionIPS.find(it => it.id.toString() === values.nutrition?.toString()),
      order: nutritionOrders.find(it => it.id.toString() === values.order?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...nutritionOrderItemEntity,
          nutrition: nutritionOrderItemEntity?.nutrition?.id,
          order: nutritionOrderItemEntity?.order?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.nutritionOrderItem.home.createOrEditLabel" data-cy="NutritionOrderItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.home.createOrEditLabel">
              Create or edit a NutritionOrderItem
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="nutrition-order-item-id"
                  label={translate('tinyMedicRestApp.nutritionOrderItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrderItem.active')}
                id="nutrition-order-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrderItem.cursor')}
                id="nutrition-order-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrderItem.lastupdated')}
                id="nutrition-order-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrderItem.microSec')}
                id="nutrition-order-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrderItem.total')}
                id="nutrition-order-item-total"
                name="total"
                data-cy="total"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrderItem.rdi')}
                id="nutrition-order-item-rdi"
                name="rdi"
                data-cy="rdi"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nutritionOrderItem.dailyTotal')}
                id="nutrition-order-item-dailyTotal"
                name="dailyTotal"
                data-cy="dailyTotal"
                type="text"
              />
              <ValidatedField
                id="nutrition-order-item-nutrition"
                name="nutrition"
                data-cy="nutrition"
                label={translate('tinyMedicRestApp.nutritionOrderItem.nutrition')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nutritionIPS
                  ? nutritionIPS.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="nutrition-order-item-order"
                name="order"
                data-cy="order"
                label={translate('tinyMedicRestApp.nutritionOrderItem.order')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nutritionOrders
                  ? nutritionOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/nutrition-order-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default NutritionOrderItemUpdate;
